import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-clients",
  "use": "svg_menu-clients-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg_menu-clients\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8ZM0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6Zm6-2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1Z\" fill=\"#99CC57\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol